module.exports = __webpack_public_path__ + "static/img/hero.589dcc4b.png";